import { settleApiCall } from '../api/utils';
import { convertModifiersInModifierGroupToDisplayedModifier, convertPopulatedModifierGroupsToModifierGroupsDTO } from '../utils/converters';
import { createModifiers } from './createModifiers';
import { categorizeByExistence } from './utils/common';
import { createKeysToModifierGroupsMap, getModifierGroupKey, getModifiersToCreate, attachModifiersToModifierGroups } from './utils/modifierGroups';
import { createFieldToEntityMap } from '../utils/common';
export const createOrUpdateModifierGroups = async _ref => {
  let {
    modifierGroups,
    modifierGroupsClient,
    modifiersClient
  } = _ref;
  const modifiers = getModifiersToCreate(modifierGroups);
  const createModifiersResponse = await createModifiers(modifiers, modifiersClient);
  if (createModifiersResponse.hasError) {
    return createModifiersResponse;
  }
  const modifierGroupsWithModifiers = attachModifiersToModifierGroups(modifierGroups, createModifiersResponse.data);
  const modifierGroupsInDTOForm = convertPopulatedModifierGroupsToModifierGroupsDTO(modifierGroupsWithModifiers);
  const {
    newEntities: newModifierGroups,
    existingEntities: existingModifierGroups
  } = categorizeByExistence(modifierGroupsInDTOForm);
  const createModifierGroupsResponse = newModifierGroups.length > 0 ? await settleApiCall(() => modifierGroupsClient.bulkCreate(newModifierGroups)) : undefined;
  if (createModifierGroupsResponse != null && createModifierGroupsResponse.hasError) {
    return createModifierGroupsResponse;
  }
  const updateModifierGroupsResponse = existingModifierGroups.length > 0 ? await settleApiCall(() => modifierGroupsClient.bulkUpdate(existingModifierGroups)) : undefined;
  if (updateModifierGroupsResponse != null && updateModifierGroupsResponse.hasError) {
    return updateModifierGroupsResponse;
  }
  const allModifierGroups = [...((createModifierGroupsResponse == null ? void 0 : createModifierGroupsResponse.data) || []), ...((updateModifierGroupsResponse == null ? void 0 : updateModifierGroupsResponse.data) || [])];
  const keysToModifierGroupsMap = createKeysToModifierGroupsMap(allModifierGroups);
  const idsToModifierGroupMap = createFieldToEntityMap(allModifierGroups, 'id');
  const modifierGroupsWithIds = modifierGroupsWithModifiers.map(modifierGroup => {
    let createdOrUpdatedModifierGroup;
    if (modifierGroup.id) {
      createdOrUpdatedModifierGroup = idsToModifierGroupMap[modifierGroup.id];
    } else {
      createdOrUpdatedModifierGroup = keysToModifierGroupsMap[getModifierGroupKey(modifierGroup)];
    }
    return {
      ...modifierGroup,
      name: createdOrUpdatedModifierGroup.name,
      id: createdOrUpdatedModifierGroup.id,
      revision: createdOrUpdatedModifierGroup.revision,
      modifiers: convertModifiersInModifierGroupToDisplayedModifier(createdOrUpdatedModifierGroup.modifiers, createModifiersResponse.data),
      businessLocationIds: createdOrUpdatedModifierGroup.businessLocationIds,
      createdDate: createdOrUpdatedModifierGroup.createdDate
    };
  });
  return {
    data: modifierGroupsWithIds,
    hasError: false
  };
};
//# sourceMappingURL=createOrUpdateModifierGroups.js.map